__turbopack_context__.v({
  "cardBase": "KCk14W_cardBase",
  "emptyCard": "KCk14W_emptyCard" + " " + "KCk14W_cardBase",
  "emptyIcon": "KCk14W_emptyIcon",
});
